import ApiHelper from '../ApiHelper.js';

const JFC_URL = "/api/job-fit-checks";

export default {
    getPreviousJobFitChecks: async function() {
        return ApiHelper.get(`${JFC_URL}`);
    },

    getActiveJobFitCheck: async function(jfcId) {
        return ApiHelper.get(`${JFC_URL}/${jfcId}`);
    },

    updateJobFitCheck: async function(jfcResult) {
        // ID comes from the body
        return ApiHelper.put(`${JFC_URL}`, jfcResult);
    },

    linkJobFitCheckToPortfolio: async function(portfolioId, jobFitCheckId, ownerId) {
        return ApiHelper.put(`${JFC_URL}/link`, {
            portfolioId,
            jobFitCheckId,
            ownerId
        });
    },

    unlinkJobFitCheckFromPortfolio: async function(portfolioId, ownerId) {
        return ApiHelper.put(`${JFC_URL}/unlink`, {
            portfolioId,
            ownerId
        });
    },

    deleteJobFitCheck: async function(jfcId) {
        return ApiHelper.delete(`${JFC_URL}/${jfcId}`);
    }
}